/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Tim_PriceInputs */

const en_cp_p_tim_price = /** @type {(inputs: Cp_P_Tim_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDR 299k`)
};

const id_cp_p_tim_price = /** @type {(inputs: Cp_P_Tim_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 299 rb`)
};

/**
* | output |
* | --- |
* | "IDR 299k" |
*
* @param {Cp_P_Tim_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_tim_price = /** @type {((inputs?: Cp_P_Tim_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Tim_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_tim_price(inputs)
	return en_cp_p_tim_price(inputs)
});